// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-to-button{position:fixed;bottom:100px;inset-inline-end:20px;width:60px;height:60px;background:rgba(0,0,0,0);border:1px solid #979797;border-radius:50%;z-index:10;cursor:pointer}.scroll-to-button.hidden{display:none}.scroll-to-button img{transform:rotate(180deg);width:15px;height:15px}.scroll-to-button__dark img{filter:invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)}", ""]);
// Exports
module.exports = exports;
